import type { RouteObject } from 'react-router';
import BackgroundLayout from '@layouts/BackgroundLayout/BackgroundLayout';
import IndexLayout from '@layouts/IndexLayout/IndexLayout';
import AppsPage from '@pages/apps/AppsPage';
import HomePage from '@pages/home/HomePage';
import PrincipalsPage from '@pages/principals/PrincipalsPage';
import UsersPage from '@pages/users/UsersPage';

const appRoutes: RouteObject[] = [
	{
		path: '/',
		Component: IndexLayout,
		children: [
			{
				Component: BackgroundLayout,
				children: [
					{ index: true, Component: HomePage },
					// Apps is tabbed, and the tab is a segment of its own. Bare
					// /apps carries no tab, so the page redirects to its default.
					{ path: 'apps', Component: AppsPage },
					{ path: 'apps/:tab', Component: AppsPage },
					{ path: 'principals', Component: PrincipalsPage },
					{ path: 'users', Component: UsersPage },
				],
			},
		],
	},
];

export default appRoutes;
